import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import * as _ from 'underscore';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { GlobalStatus, GlobalStatusKanban } from 'src/app/shared/models/iCourrier/status-management/global-status';
import { DocumentsService } from 'src/app/shared/services/documents.service';
import { GlobalSpecificStatutesService } from 'src/app/shared/services/global-specific-statutes.service';
import { MailsService } from 'src/app/shared/services/mails.service';
import { GlobalStatusDTO } from 'src/app/shared/interfaces/global/global-status.interface';
import { DocumentStatusDto } from 'src/app/shared/interfaces/documents/document-status-dto.interface';
import { MailMeSearchKanban } from 'src/app/shared/models/mails/mail-kanban';
import { MailMeSearchDto } from 'src/app/shared/interfaces';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home-courrier-kanban',
  templateUrl: './home-courrier-kanban.component.html',
  styleUrls: ['./home-courrier-kanban.component.scss'],
})
export class HomeCourrierKanbanComponent implements OnInit {
  public baseUrl: string;
  public myItems_by_status: MailMeSearchKanban[][][];
  public statusList: GlobalStatus[] = [];
  public selectedStatus: GlobalStatusKanban[] = [];

  public configStatus: { label: string; value: GlobalStatus }[] = [];
  public load: boolean = false;
  public expandID: number = null;
  public searchString: string = '';
  public currentPage: number = 1;
  public currentWeek: string = moment().format('ww');
  public today = moment();
  public nbrSeletedStatus: number = 0;
  public isLoading: boolean;
  public canDisplayStatus: boolean = false;
  @Input() set loaded(value) {
    this.load = value;
  }
  @Input() set items(_value) {
    this.myItems_by_status = [];
    this.statusList.map((status) => {
      this.myItems_by_status[+status.id] = [];
    });

    this.nbrSeletedStatus = this.selectedStatus.length;
    this.isLoading = true;
    this.selectedStatus.map((status) => {
      this.documentsService.getDocumentStatutesByGlobal(+status.id).subscribe({
        next: (res: DocumentStatusDto[]) => {
          status.documentstatus = [];
          if (res.length > 0) {
            res.map((item) => {
              if (item.notUsed === false) {
                status.documentstatus.push(item);
                status.documentstatus = _.sortBy(status.documentstatus, 'ordreAffichage');
              }
            });
          } else {
            status.documentstatus = [];
          }
        },
      });
    });
    setTimeout(() => {
      this.selectedStatus.map((status) => {
        if (status.documentstatus?.length > 0) {
          this.canDisplayStatus = true;
          status.documentstatus.map((substatus) => {
            if (substatus.notUsed === false) {
              this.mailsService.getAllMails({ StIds: [+substatus.id] }).subscribe({
                next: (res) => {
                  this.myItems_by_status[+status.id][+substatus.id] = [];

                  res.items.map((item) => {
                    const newItem = { ...item, status: item.statutId, danger: false, warning: false, normal: false };
                    if (item.dateEcheance) {
                      const transmissionDate = moment(item.dateEcheance);
                      if (transmissionDate < this.today && !transmissionDate.isSame(moment(), 'day')) {
                        newItem.danger = true;
                      }
                      if (transmissionDate.isSame(moment(), 'day')) {
                        newItem.warning = true;
                      }
                      if (transmissionDate > this.today) {
                        newItem.normal = true;
                      }
                    }
                    this.myItems_by_status[+status.id][+substatus.id].push(newItem);
                  });
                  this.load = true;
                  this.nbrSeletedStatus--;
                  if (!this.nbrSeletedStatus) {
                    this.isLoading = false;
                  }
                },
              });
            }
          });
        }
      });
    }, 1000);
  }

  @ViewChild(CdkVirtualScrollViewport) viewPort: CdkVirtualScrollViewport;

  constructor(
    public toastr: ToastrService,
    public documentsService: DocumentsService,
    private globalSpecificStatutesService: GlobalSpecificStatutesService,
    private mailsService: MailsService
  ) {}

  ngOnInit(): void {
    this.load = false;
    this.getStatusConfig().then(() => {
      this.load = true;
    });
  }

  getStatusConfig(): Promise<boolean> {
    return new Promise((resolve) => {
      this.globalSpecificStatutesService.getGlobalStatus().subscribe({
        next: (res: GlobalStatusDTO[]) => {
          this.statusList = res;
          this.selectedStatus = [];
          res.forEach((item) => {
            this.configStatus.push({ label: item.description, value: item });
            this.selectedStatus.push(new GlobalStatusKanban(item));
          });
          resolve(true);
        },
      });
    });
  }
  dropSubContainer(event: CdkDragDrop<MailMeSearchKanban[][]>): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
      const new_status = event.container.id;
      let mailObject: Partial<MailMeSearchDto & { danger?: boolean; warning?: boolean; normal?: boolean }> = null;

      event.previousContainer.data.forEach((item: MailMeSearchKanban[]) => {
        if (item?.length > 0) {
          item.forEach((mail, i) => {
            if (i === event.previousIndex) {
              mailObject = mail;
            }
          });
        }
      });

      this.mailsService.patchMailStatus(mailObject.id, +new_status).subscribe({
        next: () => {
          this.toastr.success('Le statut a bien été modifié');
          this.reload();
        },
      });
    }
  }
  expand(index): void {
    if (this.expandID === null) {
      this.expandID = index;
    } else {
      this.expandID = null;
    }
  }

  reload(): void {
    this.selectedStatus.map((status) => {
      if (status.documentstatus?.length > 0) {
        status.documentstatus.map((substatus) => {
          if (substatus.notUsed === false) {
            this.mailsService.getAllMails({ StIds: [+substatus.id] }).subscribe({
              next: (res) => {
                status.totalItems = res.totalPages;
                this.myItems_by_status[+status.id][+substatus.id] = [];
                res.items.map((item) => {
                  const newItem: MailMeSearchKanban = item;
                  newItem.status = item.statutId;
                  if (newItem.dateEcheance) {
                    const transmissionDate = moment(newItem.dateEcheance);
                    if (transmissionDate < this.today && !transmissionDate.isSame(moment(), 'day')) {
                      newItem.danger = true;
                    }
                    if (transmissionDate.isSame(moment(), 'day')) {
                      newItem.warning = true;
                    }
                    if (transmissionDate > this.today) {
                      newItem.normal = true;
                    }
                  }
                  this.myItems_by_status[+status.id][+substatus.id].push(newItem);
                });
                this.nbrSeletedStatus--;
                if (!this.nbrSeletedStatus) {
                  this.isLoading = false;
                }
              },
            });
          }
        });
      }
    });
  }

  openMail(item): void {
    const url = '/private/ic/tabs/';
    const config = environment;
    this.baseUrl = config.baseUrl;
    window.open(this.baseUrl + url + item.id);
  }
}
